import { z } from 'zod'

import { baseVanillaSchema } from '@/pages/instruments/new-instrument/schemas/shared/base-vanilla.schema'
import { contractTypeSchema } from '@/pages/instruments/new-instrument/schemas/shared/contract-type.schema'
import { sideSchema } from '@/pages/instruments/new-instrument/schemas/shared/side.schema'

export const vanillaSchema = baseVanillaSchema.extend({
  instrument_type: z.literal('vanilla'),
  contract_type: contractTypeSchema,
  side: sideSchema,
})

export type VanillaSchemaType = z.infer<typeof vanillaSchema>
